// tslint:disable-next-line:interface-name
export interface OrderLine {
    orderNo: number;
    lineNo: number;
    addressSearchName: string;
    bookedDateTimeFrom: Date;
    bookedDateTimeUntil: Date;
    orderLineID: string;
    haulierNo: string;
    truckNo: string;
    truckDescription: string;
    driverFullName: string;
    planningBlockID: number;
    containerNo: string;
    containerNumber: string;
    groupingID: number;
    actionType: number;
    transportOrderNo: string;
    supplierName: string;
    addressName: string;

}
export enum OrderLineActionsEnum {
  General = 0, Collection = 1, Unload = 2, Load = 3, Delivery = 4, Embark = 5, Debark = 6,
  Pickup = 7, Drop_at = 8, Couple = 9, Uncouple = 10, Shipping = 11, Train_On = 12, Train_Off = 13,
  Stock_In = 14, Stock_Out = 15, Via = 16, StartTO = 17, StopTO = 18, Driver_On = 19, DriverOff = 20, Break = 21,
  Embark_SD = 22, Debark_SD = 23, Railway = 24, Airway = 25, FA = 26, FD = 27, StartO = 28, StopO = 29, Rest = 30,
  Storage = 31, Handling = 32, DOut = 33, DIn = 34, Scan = 35, Customs = 36, Weighing = 37
}

